module.exports = __webpack_public_path__ + "img/Einschulung.be7c9dd2.jpg";